import {useTranslation} from "react-i18next";
import useCustomTranslation from "core/customTranslation";
import Form from "react-bootstrap/Form";
import {useRef, useState, useEffect} from "react";
import {SwalAlertClass} from "core/swalClass";
import {useNavigate} from "react-router-dom";
// -
import ProgressBar from "react-bootstrap/ProgressBar";
import TableWarnings from "./TableWarnings";
import apiAxi from "ApiCaller";
import WsConnector from "core/wsConnector";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";

const checksStatus = {
    // checkbox status
    create: false,
    recovery: false,
};

const translations = {
    es: {
        "recovering-data": "Recuperando datos",
        "creating-devices": "Creando dispositivos",
    },
    en: {
        "recovering-data": "Recovering data",
        "creating-devices": "Creating devices",
    },
};

const TabResult = ({warns, token, roomID}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const navigate = useNavigate();
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [percent, setPercent] = useState(0);
    const [statusChecks, setStatusChecks] = useState(checksStatus);
    const warnings = useRef([]);
    const [warningsShow, setWarningsShow] = useState([]);
    const [error, setError] = useState("");
    const [ended, setEnded] = useState(false);

    const wsConn = new WsConnector();
    wsConn.message = (e) => {
        let data = JSON.parse(e.data);
        if (data.end) {
            let checks = checksStatus;
            checks[data.end] = true;
            setStatusChecks(checks);
        }
        if (data.error) {
            setError(data.error);
            warnings.current.push({line: 0, active: "Error", message: data.error});
            setWarningsShow([...warnings.current]);
        }
        setPercent(parseInt(data.percent));
        if (data.warning) {
            warnings.current.push(data.warning);
            setWarningsShow([...warnings.current]);
        }
        if (data.ended) {
            wsConn.ws.close();
            setEnded(true);
        }
    };
    const acceptImport = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        if (!e.detail) {
            return;
        }

        apiAxi
            .post(`/api/plugins/inventory/accept/${token}/`, e.detail)
            .then((resp) => {
                if (resp.data.status) {
                    console.log("[TabResult].activeWebsocket()");
                    wsConn.setUrl(`/ws/inventory/plugin/import/${e.detail.room}/`);
                    wsConn.connect();
                }
            })
            .catch((error) => {
                console.error(error);
                Alert.error("Error", "Al aceptar el inventario").then(() => {
                    navigate("/asset-management/imports/");
                });
            });
    };

    useEffect(() => {
        warnings.current = [...warns.current];
        setWarningsShow([...warns.current]);
        subscribeEvent("notifyplugininventoryacceptimport", acceptImport);

        return () => {
            unsubscribeEvent("notifyplugininventoryacceptimport", acceptImport);
            wsConn.close();
        };
    }, []);

    return (
        <div className="row">
            <div className="col-md-10 col-12 m-auto">
                <div className="row">
                    <div className="col-12">
                        <p>{_Tf("inventory.title-tab-result")}</p>
                        <p>{_Tf("inventory.title-tab-result-description")}</p>
                    </div>
                    <div className="col-md-6 col-12">
                        <Form.Check
                            disabled
                            type="checkbox"
                            className="mb-2"
                            label={_TC("recovering-data")}
                            id="check-recovery"
                            checked={statusChecks.recovery}
                        />
                        <Form.Check
                            disabled
                            type="checkbox"
                            className="mb-2"
                            label={_TC("creating-devices")}
                            id="check-create"
                            checked={statusChecks.create}
                        />
                    </div>
                    {ended && !error ? (
                        <div className="col-md-10 col-12 text-center">
                            <h3 className="text-success">{_Tf("text.ended-correctly")}</h3>
                        </div>
                    ) : (
                        <></>
                    )}
                    {error ? (
                        <div className="col-md-6 col-12 text-danger">
                            <h5>{_Tf("labels.error")}:</h5>
                            <p>{error}</p>
                            <p className="text-danger">{_Tf("inventory.error")}</p>
                        </div>
                    ) : (
                        <></>
                    )}
                    {!ended ? (
                        <div className="col-12 mt-5">
                            <h5>Progreso</h5>
                            <ProgressBar striped variant="info" now={percent} label={`${percent}%`} />
                        </div>
                    ) : (
                        <></>
                    )}
                    {warningsShow.length ? <TableWarnings items={warningsShow} /> : <></>}
                </div>
            </div>
        </div>
    );
};

export default TabResult;
